export enum LineType {
  Unknown = 0,
  Advertising = 1,
  Service = 2,
}
